import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import Resources from "../components/Resources";

export default function ResourcesPage() {
  return (
    <div
      data-testid="resources-page-root"
      className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] font-body"
    >
      <Navbar />
      <main className="pt-28 lg:pt-32">
        <div className="px-5 lg:px-10 max-w-[1320px] mx-auto mb-2">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E]">
            <Link to="/" className="hover:text-[#0A0A0A]">
              Home
            </Link>{" "}
            / Resources
          </div>
        </div>
        <Resources />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
